export const AUTHENTICATION_STORAGE_KEY = 'isAuthenticated';
export const AUTHENTICATION_STORAGE_TOKEN = 'SsP4dwupbmvXZ9BstAXUueYM6uf3Hy';
